import { supabase } from '../lib/supabaseClient';
import { CardSummary } from '../types/cards';

/**
 * 카드 ID 배열로 카드 정보를 가져옵니다.
 */
export async function fetchCardsByIds(cardIds: number[]): Promise<CardSummary[]> {
  if (cardIds.length === 0) {
    return [];
  }

  const {
    data: { session },
  } = await supabase.auth.getSession();

  if (!session) {
    throw new Error('Unauthorized');
  }

  const { data: cards, error } = await supabase
    .from('cards')
    .select('id, name, image_url, grade, description, cost, attack, defense, hp, card_type, attribute, skill_name, skill_description, skill_effect')
    .in('id', cardIds);

  if (error) {
    throw error;
  }

  // CardSummary 형식으로 변환
  return (cards || []).map((card) => ({
    id: card.id,
    name: card.name,
    image_url: card.image_url,
    grade: card.grade as CardSummary['grade'],
    description: card.description || '',
    count: 1, // 게임에서는 항상 1장
    cost: card.cost,
    attack: card.attack,
    defense: card.defense,
    hp: card.hp,
    card_type: card.card_type as CardSummary['card_type'],
    attribute: card.attribute as CardSummary['attribute'],
    skill_name: card.skill_name,
    skill_description: card.skill_description,
    skill_effect: card.skill_effect as CardSummary['skill_effect'],
  }));
}

